/**
 * OpenMetadata FQN에서 MLflow 모델명을 추출합니다
 *
 * @description
 * OpenMetadata의 mlmodel FQN은 "service.schema.modelName" 형식입니다.
 * MLflow API는 모델명만 필요하므로 FQN의 마지막 세그먼트를 추출합니다.
 *
 * @param fqn - OpenMetadata mlmodel FQN (예: "mlflow_service.default.iris_pytorch_net")
 * @returns MLflow 모델명 (예: "iris_pytorch_net")
 *
 * @example
 * ```typescript
 * const fqn = "mlflow_service.default.iris_pytorch_net";
 * const modelName = extractModelNameFromFQN(fqn);
 * // 결과: "iris_pytorch_net"
 * ```
 */
export const extractModelNameFromFQN = (fqn: string): string => {
  if (!fqn || typeof fqn !== 'string') {
    return '';
  }

  const parts = fqn.split('.');
  return parts[parts.length - 1] || '';
};
